
import Modal from "../Shared/Modal/Modal";
import stylez from "./ProductsModal.module.css";
import { useNavigate } from 'react-router-dom';

const ProductsModal =({show,setShow,products,title,update,order})=>{
  console.log(products);
  
  const navigate = useNavigate();
 
    const handleClick = (i)=>{
      navigate('/salesOrders/updateOrder', { state: i });
    }
    return(
    <Modal show={show} setShow={setShow}>
        <div className={stylez.modalContainer}>
        <h2 className={stylez.modalHeader}>{title && title}</h2>
        <div className={stylez.modalContent}>
          <table className={stylez.productTable}>
            <thead>
              <tr>
                <th>ProductName</th>
                <th>Quantity</th>
                <th>Weight</th>
              </tr>
            </thead>
            <tbody>
              {products?.map((i) => (
                <tr>
                  <td>{i?.product?.productName}</td>
                  <td>{i?.quantity}</td>
                  <td>{i?.product?.weight}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={stylez.footer}>
          {update && <button style={{marginRight:"10px"}} className="editBtn" onClick={()=>handleClick(order)}>Update Order</button>}
          <button
            style={{
              backgroundColor: 'red',
              color: 'white',
              marginTop: '10px',
              padding:"10px"
            }}
            onClick={() => setShow(false)}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
    )

}
export default ProductsModal;